import { Component, Input } from '@angular/core';
import { ArrayUtils } from '../../../utils';

@Component({
  selector: 'lib-simple-step-process',
  templateUrl: './simple-step-process.component.html',
  styleUrls: ['./simple-step-process.component.scss'],
})
export class SimpleStepProcessComponent {
  @Input() set totalSteps(value: number) {
    this.steps = ArrayUtils.getDummyArray(value);
  }
  @Input() numberOfFinishedSteps = 0;

  public steps: number[];

  public isStepActive(index: number): boolean {
    return index + 1 <= this.numberOfFinishedSteps;
  }
}
